import Modal from "../components/modal";
import react from 'react';

export default class DefineAreaPrecisionModal extends react.Component {
  constructor(props) {
    super(props);

    this.state = { 
      show: props.show,
      hideAction: props.hideAction
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside() {
    this?.state?.hideAction && this?.state.hideAction();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ show: nextProps.show });  
  }

  render() {
    return (
      <>
        <Modal show = {this.state.show} header = {"Fence and precision"} hideAction = {this.state.hideAction}>
          <div className="mb-6">
            <h3 className="h4-font-size subheading">Fence</h3>
            <p>The fence in which the route will be calculated. Smaller fences are faster for calculating. Start and end point has to be inside the fence. </p>
            <img src="../obstacles-area.png" alt="Calculation fence" className="d-block mx-auto object-fit-cover rounded" />
          </div>
          <div className="mb-6">
            <h3 className="h4-font-size subheading">Precision</h3>
            <p>Defines how much effort the generator will put for calculating the best route. Higher number increases possibility of finding better way but will take more time to calculate.</p>
            <div className="d-flex align-items-center">
              <img src="../obstacles-precision-01.png" alt="Smaller precision" className="rounded object-fit-cover overflow-hidden mr-6" />
              <div className="icon icon-less-than h4-font-size text-fade-color mr-6" />
              <img src="../obstacles-precision-02.png" alt="Higher precission" className="rounded object-fit-cover overflow-hidden mr-6" />
            </div>
          </div>
        </Modal>
      </>
    );
  }
};
